<script lang="ts">
  import { Sparkle } from "phosphor-svelte";

  export let count: number = 0;
</script>

<div class="achievement" class:earned={count > 0}>
  <div class="circle">
    <Sparkle size="1rem" />
    {#if count >= 1}
      <div class="multiple">
        {count}x
      </div>
    {/if}
  </div>
  <div class="title">Glitter Milestones</div>
</div>

<style>
  .achievement {
    display: flex;
    gap: 1rem;
    align-items: center;
  }
  .title {
    font-size: 0.8rem;
    color: var(--title);
  }
  .achievement .circle {
    font-size: 1rem;
    font-weight: bold;
    background: white;
    color: var(--comment_accent);
    border: 2px solid var(--dots);
    border-radius: 50%;
    width: 2rem;
    aspect-ratio: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
  }

  .multiple {
    position: absolute;
    bottom: -0.3rem;
    right: -0.5rem;
    background: var(--secondary);
    color: white;
    font-size: 0.6rem;
    border: 2px solid var(--dots);
    border-radius: 0.25rem;
    padding: 0.1rem 0.2rem;
    z-index: 1;
  }
  .achievement.earned .circle {
    background: var(--dots);
    color: var(--offDark);
    border: 2px solid var(--comment_accent);
  }
</style>
